import { ColumnDef, CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";
import { Link } from "react-router-dom";
import { RequestDealerModel } from "../../../dailyPlanning/domain/models/dealerModel";
import { CarTireSetModel } from "../../../../car/domain/models/carTireSetModel";
import { CarTireModel } from "../../../../car/domain/models/carTireModel";

export const SlipRequestTableColumns: ColumnDef<RequestDealerModel>[] = [
  {
    id: "select",
    cell: (ctx: CellContext<RequestDealerModel, unknown>) => {
      type MetaType = {
        selectedIds: string[];
        setSelectedIds?: (ids: string[]) => void;
      };
      const meta = ctx.table.options.meta as MetaType | undefined;
      const selectedIds = meta?.selectedIds || [];
      const setSelectedIds = meta?.setSelectedIds;
      const rowId = ctx.row.original.id;
      const checked = selectedIds.includes(rowId);
      return (
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => {
            if (!setSelectedIds) return;
            const isChecked = e.target.checked;
            setSelectedIds(
              isChecked
                ? [...selectedIds, rowId]
                : selectedIds.filter((id) => id !== rowId),
            );
          }}
        />
      );
    },
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    id: "source.car.licence",
    accessorKey: "source.car.licence",
    header: "licence",
    enableSorting: false,
    cell: (ctx: CellContext<RequestDealerModel, unknown>) => {
      const { t } = useTranslation("common");
      const source: CarTireSetModel | CarTireModel | undefined =
        ctx.row.original.source;
      const car =
        source && "car" in source ? (source as CarTireSetModel).car : undefined;
      const licence = car?.licence ?? "";
      const label = car?.label ?? t("deleted_or_unknown");
      const plate = new LicensePlate(licence);
      return (
        <Link to={"/requests/" + ctx.row.original?.id} target={"_blank"}>
          <div className="d-flex align-items-center gap-2">
            {licence && (
              <div
                className="tireset-table-licence-plate"
                style={{
                  background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
                }}
              >
                <div>{plate.valid() ? plate.pretty() : licence}</div>
              </div>
            )}
            <div>{label}</div>
            {ctx.row.original.requestTires?.map((tire) => (
              <span key={tire.id}>{tire.tire.car_position || "Unknown"} </span>
            ))}
          </div>
        </Link>
      );
    },
  },
  {
    accessorKey: "source.type",
    header: "type",
    enableSorting: false,
    cell: ({ row }) => {
      const label = row.original.source?.type;
      const { t } = useTranslation("common");
      return t(label ?? "");
    },
  },
  {
    accessorKey: "state",
    header: "state",
    cell: ({ row }) => {
      const state = row?.original.state;
      const { t } = useTranslation("common");

      if (state === undefined) return;

      return <span className={"badge bg-" + state}>{t(state)}</span>;
    },
  },
  {
    accessorKey: "pickup_and_delivery_date",
    header: "b_o_date",
    enableSorting: true,
    cell: ({ row }) => {
      const dateString = row?.original.pickup_and_delivery_date;

      if (dateString === undefined || dateString === "" || dateString === null)
        return;
      const date = new Date(dateString);
      const formattedDate = new Intl.DateTimeFormat("en-GB")
        .format(date)
        .replace(/\//g, "-");
      return <span className={"text-nowrap"}>{formattedDate}</span>;
    },
  },
  {
    accessorKey: "work_order_number",
    header: "work_order_number",
  },
];

export const SlipPickupRequestTableColumns: ColumnDef<RequestDealerModel>[] = [
  ...SlipRequestTableColumns,
  {
    accessorKey: "source.position.label",
    header: "position",
    enableSorting: false,
  },
];
